<div class="auth-bg">
    <span class="blob blob-a" aria-hidden="true"></span>
    <span class="blob blob-b" aria-hidden="true"></span>
    <span class="blob blob-c" aria-hidden="true"></span>

    <div class="auth-card">
        <span class="brand-bar" aria-hidden="true"></span>
        <div class="auth-card-body">
            <ng-content></ng-content>
        </div>
    </div>
</div>
